const navMenuTitles = Object.freeze({
  Security: 'Seguridad',
  Student: 'Estudiante',
  Operations: 'Operaciones',
  Books: 'Libros',
  HumanResources: 'Recursos Humanos',
  User: 'Usuario',
  Pei: 'PEI',
});

export default navMenuTitles;
